import React from "react";

const PricingTable = () => {
  const serviceCategories = [
    {
      category: "User Authentication (Sign-in Methods)",
      services: [
        { name: "Google Sign-in", android: "20K", ios: "30K"},
        { name: "Facebook Login", android: "18K", ios: "28K"},
        { name: "Phone OTP Login", android: "25K",ios:'30K' },
        { name: "Custom Sign-in (Email & Password)", android: "30K", ios: "30K" },
        { name: "Apple Sign-in", ios: "35K" },
      ],
    },

    {
  category: "Notifications & User Engagement",
  services: [
    { name: "Push Notifications (Firebase)", android: "5K", ios: "5K" },
    { name: "APN INTEGRATION", ios: "10K" },
    { name: "In-App Notifications", android: "5K", ios: "5K" },
  ],
   note: "Disucss for more features and pricing.",
},
    
    
    

    {
      category: "Chat System",
      note: '* indicates features that may involve additional costs or limitations. Additional notes:\n- "Server cost" applies to Video Share, Voice Call, and Video Call (actual cost depends on third-party provider).\n- "Selective Message Reply" is not available in the free package and requires integration with a new third-party solution.',
      services: [
        { name: "Voice Chat", android: "30K", ios: "30K" },
        { name: "Audio Share", android: "15K", ios: "15K" },
        { name: "Video Share*", android: "16K", ios: "16K" },
        { name: "Contact Share*", android: "6K", ios: "6K" },
        { name: "Mute Notification", android: "10K", ios: "10K" },
        { name: "Disappearing Messages", android: "17K", ios: "17K" },
        { name: "Message Edit", android: "10K", ios: "10K" },
        { name: "Voice Note", android: "28K", ios: "28K" },
        { name: "Search Message", android: "7K", ios: "7K" },
        { name: "Export Chat", android: "7K", ios: "7K" },
        { name: "Pin Chat", android: "7K", ios: "7K" },
        { name: "Star Message", android: "7K", ios: "7K" },
        { name: "Shortcuts (WP)", android: "10K", ios: "10K" },
        { name: "Label 🏷️ (WP)", android: "13K", ios: "13K" },
        { name: "Photo Editing", android: "34K", ios: "34K" },
        { name: "Groups Creation and Chat", android: "45K", ios: "45K" },
        { name: "Voice Call", android: "44K", ios: "44K" },
        { name: "Video Call", android: "44K", ios: "44K" },
        { name: "Selective Message Reply*" },
        { name: "Group Chat (Advanced)", android: "100K", ios: "100K" },

      ],
    },
   

    {
  category: "Admin Panel & Analytics",
  services: [
    { name: "Basic Admin Panel (CRUD)", price: "20K", unit: "Starting" },
    { name: "Advanced Admin Dashboard (Charts & Reports)", price: "30K+", unit: "Starting" },
    { name: "User Management & Controls", price: "8K", unit: "One-time" },
    { name: "App Analytics (Firebase / GA)", android: "8K", ios: "8K" },
    { name: "Crash & Performance Monitoring", android: "6K", ios: "6K" },
  
  ],
    note: "Disucss for more features and pricing.",
},



{
      category: "App Store Deployment Fees",
      note: "Pricing is subject to change if the project scope expands beyond initial agreement, or if additional features, modifications, or platform-specific requirements are introduced.",
      services: [
        { name: "Google Play Store Setup*", price: "3K", unit: "One-time" },
        { name: "Apple App Store Setup*", price: "25K", unit: "One-time" },
        { name: "Server Configuration", price: "40K", unit: "Starting" },
        { name: "Web Deployment", price: "3K", unit: "One-time" },
        { name: "Deployment Support", price: "FREE", unit: "Zero Charges" },
      ],
    }, 


{
      category: "Apple App Store Compliance & Review Requirements",
      services: [
        {
          name: "iPad Screen Adaptation",
          ios: "30K",
        },
        {
          name: "Apple Review Approval Mechanism",
          ios: "25K",
        },
        {
          name: "App Store Guideline Compliance Fixes",
          ios: "30K",
        },
      ],
      note: "These charges are applicable only for iOS apps and depend on App Store review feedback.",
    },

    
    {
  "category": "Alterations & Add-ons",
  "note": "Charges apply only for requests beyond the initial agreed scope. All add-on prices are starting estimates and may vary based on complexity and sitution,• Advanced or enterprise-level features may require additional backend, server, or third-party service costs.",
  "services": [
    { "name": "Dedicated Screen (Custom)", "android": "10K", "ios": "10K" },
    { "name": "App Performance Optimization", "android": "10K", "ios": "10K" },
    { "name": "Minor Bug Fix / UI Adjustment", "android": "1K", "ios": "1-3K" },
    { "name": "App Screen Mockups (Designed)", "android": "800", "ios": "800" },
    { "name": "App Logo Design / icon", "price": "1000-10000", "unit": "Per unit"},
    { "name": "Compliance Documentation (Privacy Policy, Terms, etc.)", "android": "8K–20K", "ios": "8K–20K" },
    { "name": "Testing Required By Playstore*" },
    { "name": "New Add-on Feature (Basic)", "android": "5K+", "ios": "5K+" },
    { "name": "Firebase Read Optimization (Cost Control)", "android": "7K", "ios": "7K" },
    { "name": "App Store Optimization (ASO)", "android": "4K–6K", "ios": "4K–6K" },
    { "name": "Review Response Setup (Auto/Manual)", "android": "2.5K", "ios": "2.5K" },
     { "name": "YT THUMNAIL / BANNER / 16:9", "price": "400-1000", "unit": "Per unit" },
    { "name": "Review Addup on Platform (1000 Reviews)", "android": "25K", "ios": "45K" }, 
    { "name": "Pdf Maker", "android": "10K", "ios": "10K" },
    { "name": "Play Console / App Store (except platform fees)", "android": "1K", "ios": "1K" },
{ "name": "Social Media Marketing", "android": "7-12K", "ios": "7-12K" },
{ "name": "PPC Advertising (Google / Meta Ads)", "android": "10–20K", "ios": "10–20K" },
{ "name": "Ads Integration (AdMob / Meta)", "android": "10K", "ios": "12K" },
{ "name": "In-App Survey / Feedback", "android": "4K", "ios": "4K" },
{ "name": "DBMS", "android": "24K", "ios": "24K" },
{ "name": "Channel System (Telegram-style)", "android": "30K", "ios": "40K" },
{ "name": "CSV / Excel Export", "price": "4K", "unit": "One-time" },
{ "name": "Version Upgrade Support (Major Release)", "price": "10K+", "unit": "Per release" },

    
  ]
}
  ];

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <div className="space-y-10">
        {serviceCategories.map((cat, idx) => (
          <div key={idx} className="space-y-4">
            {/* Category Name - Pehle se chota aur simple */}
            <h2 className="text-xl font-bold text-foreground flex items-center gap-2">
              <span className="w-1.5 h-6 bg-primary rounded-full"></span>
              {cat.category}
            </h2>

            {/* List Container */}
            <div className="grid grid-cols-1 gap-2">
              {cat.services.map((service, sIdx) => (
                <div
                  key={sIdx}
                  //   className="bg-card rounded-lg p-3 px-5 brand-shadow flex flex-row items-center justify-between border border-border/40 hover:border-primary/40 transition-all"
                  className="bg-card rounded-lg px-4 py-3 brand-shadow flex items-center gap-4 border border-border/40 hover:border-primary/40 transition-all"
                >
                  {/* Item Name - Left side mein fix */}
                  <div className="flex-1">
                    {/* <div className="pr-4"> */}
                    <h3 className="font-semibold text-foreground text-base">
                      {service.name}
                    </h3>
                  </div>

                  {/* Pricing - Right side mein pass-pass */}
                  {/* <div className="flex items-center gap-2 ml-auto">

                    {service.android ? (
                      <div className="flex items-center gap-2">
                        <div className="bg-surface px-3 py-1 rounded border border-border flex flex-col items-center min-w-[70px]">
                          <span className="text-[9px] uppercase font-bold text-muted-foreground">Andr</span>
                          <span className="text-sm font-bold text-foreground">₹{service.android}</span>
                        </div>
                        <div className="bg-surface px-3 py-1 rounded border border-border flex flex-col items-center min-w-[70px]">
                          <span className="text-[9px] uppercase font-bold text-muted-foreground">iOS</span>
                          <span className="text-sm font-bold text-foreground">₹{service.ios}</span>
                        </div>
                       
                      </div>
                    ) : (
                      <div className="bg-conversion/10 px-4 py-1.5 rounded border border-conversion/20 text-right">
                        <span className="text-base font-bold text-foreground mr-2">₹{service.price}</span>
                        <span className="text-[10px] text-muted-foreground uppercase">{service.unit}</span>
                      </div>
                    )}
                  </div> */}
                  <div className="flex items-center gap-2 ml-auto">
                    {/* ANDROID PRICE */}
                    {service.android && (
                      <div className="bg-surface px-3 py-1 rounded border border-border flex flex-col items-center min-w-[70px]">
                        <span className="text-[9px] uppercase font-bold text-muted-foreground">
                          Andr
                        </span>
                        <span className="text-sm font-bold text-foreground">
                          ₹{service.android}
                        </span>
                      </div>
                    )}

                    {/* IOS PRICE */}
                    {service.ios && (
                      <div className="bg-surface px-3 py-1 rounded border border-border flex flex-col items-center min-w-[70px]">
                        <span className="text-[9px] uppercase font-bold text-muted-foreground">
                          iOS
                        </span>
                        <span className="text-sm font-bold text-foreground">
                          ₹{service.ios}
                        </span>
                      </div>
                    )}

                    {/* PRICE / UNIT (ONE-TIME / STARTING ETC) */}
                    {!service.android && !service.ios && service.price && (
                      <div className="bg-conversion/10 px-4 py-1.5 rounded border border-conversion/20 text-right">
                        <span className="text-base font-bold text-foreground mr-2">
                          ₹{service.price}
                        </span>
                        <span className="text-[10px] text-muted-foreground uppercase">
                          {service.unit}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {cat.note && (
              <p className="mt-3 pl-4 text-sm font-semibold text-muted-foreground tracking-wide">
                {cat.note}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PricingTable;
